import { ChartTimeSeriesLineTheme } from '@hcs/design-system';
import { DateStr } from '@hcs/types';

import { CerberusStatsHpiChart } from '../../components';
import { MACRO_INSIGHTS_FROM_DATE } from '../../constants';
import { useZipHpiTimeSeries } from '../../hooks';

const dataHcName = 'zip-hpi-chart';

interface ZipHpiChartProps {
  className?: string;
  zipcode: string;
  fromDate?: DateStr;
  toDate?: DateStr;
  theme?: Partial<ChartTimeSeriesLineTheme>;
}
export const ZipHpiChart = ({
  zipcode,
  className,
  fromDate = MACRO_INSIGHTS_FROM_DATE,
  toDate,
  theme,
}: ZipHpiChartProps) => {
  const { data, isLoading } = useZipHpiTimeSeries({
    zipcode,
    fromDate,
    toDate,
  });
  return (
    <CerberusStatsHpiChart
      dataHcName={dataHcName}
      className={className}
      theme={theme}
      data={data}
      isLoading={isLoading}
    />
  );
};
